import React, { useRef } from "react";
import FinancialMortgage from "../../assets/useCases/FinancialMortgage.png";
import CourtCases from "../../assets/useCases/CourtCases.png";
import HealthHistory from "../../assets/useCases/HealthHistory.png";
import LegalDocuments from "../../assets/useCases/LegalDocuments.png";

import { ArrowLeft, ArrowRight } from "react-feather";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const UseCases = ({ windowSize, useCasesData, title = "Popular Use Cases"
  , description = "While the use cases for our certified and standard translation services are endless, there are some common use cases that we see daily."
  , pt = "pt-20" }) => {
  const useCaseItems = useCasesData ? useCasesData : [
    {
      title: "Financial Mortgage Processing",
      image: FinancialMortgage,
    },
    {
      title: "Legal Court Cases",
      image: CourtCases,
    },
    {
      title: "Medical Health History",
      image: HealthHistory,
    },
    {
      title: "Legal Documents",
      image: LegalDocuments,
    },
  ];

  const sliderRef = useRef(null);

  const settings = {
    infinite: true,
    slidesToShow: 2,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const nextSlide = () => sliderRef.current.slickNext();
  const prevSlide = () => sliderRef.current.slickPrev();

  return (
    <div className={`${pt}`} id="UseCases">
      <div className=" bg-white p-8 rounded-4xl shadow-md">
        <div className="space-y-4 pt-12">
          <h2 className="font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase md:text-left text-center">
            {title}
          </h2>
          <p className="text-[#686F7B] text-base xl:w-[28%] md:w-1/2 w-full md:text-left text-center">
            {description}
          </p>
        </div>

        {windowSize.width < 768 ? (
          <>
            <Slider {...settings} ref={sliderRef} className="mt-4">
              {useCaseItems.map((item, index) => (
                <div className="md:p-4 pb-4">
                  <div
                    key={index}
                    className="border border-[#E6E7E9] rounded-[20px] p-4 space-y-4"
                  >
                    <h3 className="font-secondary font-medium md:text-3xl text-2xl text-tertiary">
                      {item.title}
                    </h3>
                    <div className="flex justify-center">
                      <img src={item.image} className="w-max h-[170px]" alt="" />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            <div className="w-full flex  gap-4 justify-center md:mt-4 mt-0">
              <button
                onClick={prevSlide}
                className="bg-primary p-3 rounded-full"
              >
                <ArrowLeft className="h-5 w-5 text-white" />
              </button>
              <button
                onClick={nextSlide}
                className="bg-primary p-3 rounded-full"
              >
                <ArrowRight className="h-5 w-5 text-white" />
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5 pt-8">
              {useCaseItems.map((item, index) => (
                <div
                  key={index}
                  className="border border-[#E6E7E9] rounded-[20px] p-4 space-y-4"
                >
                  <h3 className="font-secondary font-medium md:text-3xl text-2xl text-tertiary">
                    {item.title}
                  </h3>
                  <div className="flex justify-center">
                    <img src={item.image} className=" w-max h-[170px]" alt="" />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UseCases;
